import { withInstall } from '../../utils/install';

import Affix from './index.vue';

export const IvueAffix = withInstall(Affix);
export default IvueAffix;

export * from './index.vue';
